<template>
    <div class="page-content">
        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.feedback.title')"></div>
        <!--    页面标题 end -->

        <Row type="flex" justify="center">
            <!--        侧边栏 start -->
            <i-col :lg="4">
                <SideBar class="mobile-no-sidebar" />
            </i-col>
            <!--        侧边栏 end -->

            <!--            意见和建议 start-->
            <i-col :xs="24" :md="24" :lg="12">
                <div class="feedback-block">
                    <div class="feedback-header">
                        <div class="feedback-title">{{$t('message.feedback.headerTitle')}}</div>
                        <div class="feedback-icon">
                            <m-icons type="ico_feedback" size="30" color="#0d6fb8"></m-icons>
                        </div>
                    </div>

                    <div class="line line-wrapper" />

                    <div class="feedback-list">
                        <div v-for="(feedback, index) in feedbackList" :key="index" >
                            <div class="feedback-item" @click="jumpTo('/SubmitFeedback', feedback)">
                                <div class="feedback-name">{{feedback.title}}</div>
                                <div class="type-choose">
                                    <div class="feedback-types">{{feedback.showTypes}}</div>
                                    <div class="feedback-rightarrow">
                                        <Icon type="ios-arrow-forward" size="20" color="#b2b2b2" />
                                    </div>
                                </div>
                            </div>
                            <div class="line line-wrapper" />
                        </div>

                    </div>

                </div>

            </i-col>
            <!--            意见和建议 end-->

        </Row>

    </div>
</template>

<script>
  import SideBar from "../../components/SideBar/SideBar";
  import mIcons from "../../components/m-icons/m-icons.vue";
  import {gotoPage} from "../../common/common";
  export default {
    name: "Feedback",

    data() {
      return {
        // 反馈数据
        feedbackList: this.$t('message.feedback.feedbackData'),
      }
    },

    methods: {
      // 页面跳转
      jumpTo(path, feedback) {
        gotoPage({
          path,
          params: {title: feedback.title, reasons: JSON.stringify(feedback.reasons)}
        });
      }
    },

    components: {mIcons, SideBar}
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "Feedback.scss";

</style>
